import { approvalReceived } from '../../../../../img/images';
import { ILocalization } from '../../../../../localization/definitions/types';
import { InstructionTickIcon } from '../../../../shared/icons/icons';

export const ApprovalReceivedSlideImage = () => {
    return (
        <div className='carousel-img w-100 h-100'>
            <div className='approval-received-slide'>
                <img alt='' src={approvalReceived} />
            </div>
        </div>
    );
};

export const ApprovalReceivedSlideImageSrc = approvalReceived;

interface Props {
    localization: ILocalization;
}

export const ApprovalReceivedSlideContent = ({ localization }: Props) => {
    const { approvalReceivedSlide } =
        localization.localizationStrings.susy.thesisManagement.tutorial.user
            .slides;

    return (
        <div className='tutorial-content-wrapper'>
            <h1>{approvalReceivedSlide.approvalReceived}</h1>
            <h4>{approvalReceivedSlide.goToProjectDetailsPage}</h4>

            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {approvalReceivedSlide.pickYour}{' '}
                    <span className='instruction-content-bold'>
                        {approvalReceivedSlide.secondSupervisor}
                    </span>
                    .
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {approvalReceivedSlide.waitUntil}{' '}
                    <span className='instruction-content-bold'>
                        {approvalReceivedSlide.acceptedInvitation}
                    </span>
                    .
                </div>
            </div>
            <div className='instruction-row'>
                <div className='instruction-tick'>
                    <InstructionTickIcon />
                    <div />
                </div>
                <div className='instruction-content'>
                    {approvalReceivedSlide.nowYouCan}{' '}
                    <span className='instruction-content-bold'>
                        {approvalReceivedSlide.formallyRegisterProject}
                    </span>{' '}
                    {approvalReceivedSlide.startWriting}
                </div>
            </div>
        </div>
    );
};
